import React from 'react';
import {
  findValueById, toMoney,
  Warenkorb, findBaustein,
  replaceEURinValueSet,
} from 'ion-lib';
import { useSelector } from 'react-redux';
import i18next from 'i18next';

const WarenkorbInhalt = () => {
  const zahlweise = useSelector((state) => state.daten.zahlweise);
  const bausteine = useSelector((state) => state.daten.bausteine);
  const auswahlBaustein = useSelector((state) => state.daten.auswahlBaustein);
  const laufzeit = useSelector((state) => state.daten.laufzeit);
  const auswahlVersicherung = findBaustein(bausteine, auswahlBaustein);

  const auswahlBausteine = [
    auswahlVersicherung.naturgefahren.value && (
      i18next.t('beantragen.warenkorb.naturgefahren')
    ),
    auswahlVersicherung.notfalldienste.value && (
      i18next.t('beantragen.warenkorb.notfalldienst')
    ),
    auswahlVersicherung.fahrraddiebstahl.value && (
      i18next.t('summingup.fahrrad')
    ),
  ];

  const warenkorbInhalt = {
    inhalte: [
      {
        name: 'Ihr Produkt',
        inhalt: auswahlVersicherung.label.value,
        visible: true,
      },
      {
        name: 'Selbstbeteiligung:',
        inhalt: findValueById(replaceEURinValueSet(auswahlVersicherung.selbstbeteiligung.valueSet), auswahlVersicherung.selbstbeteiligung.value),
        visible: true,
      },
      {
        name: 'Bausteine:',
        inhalt: (
          <div className="text-end">
            Inklusive
            {' '}
            {auswahlBausteine.filter(Boolean).join(', ')}
          </div>
        ),
        visible: auswahlBausteine.filter(Boolean).length > 0,
      },
      {
        name: 'Beitrag Hausrat:',
        inhalt: toMoney(auswahlVersicherung.bruttoBeitragHausrat.value),
        visible: auswahlVersicherung.glasversicherung.value,
      },
      {
        name: 'Beitrag Glas:',
        inhalt: toMoney(auswahlVersicherung.bruttoBeitragGlas.value),
        visible: auswahlVersicherung.glasversicherung.value,
      },
      {
        name: 'Vertragslaufzeit:',
        inhalt: findValueById(laufzeit.valueSet, laufzeit.value),
        visible: true,
      },
    ],
    beitrag: {
      name: `Beitrag ${findValueById(zahlweise.valueSet, zahlweise.value)}:`,
      inhalt: toMoney(auswahlVersicherung.bruttoBeitrag.value),
    },
  };

  return (
    <Warenkorb
      warenkorbInhalt={warenkorbInhalt}
    />
  );
};

export default WarenkorbInhalt;
